(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dakeya-featured-journal"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-journal]').forEach(section=>{
 const track=section.querySelector('.dakeya-journal__track'),prev=section.querySelector('[data-journal-prev]'),next=section.querySelector('[data-journal-next]');
 const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};
 prev.addEventListener('click',()=>track.scrollBy({left:-(track.firstElementChild?.clientWidth||300)-18,behavior:'smooth'}));
 next.addEventListener('click',()=>track.scrollBy({left:(track.firstElementChild?.clientWidth||300)+18,behavior:'smooth'}));
 track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
});

  } catch(e) { console.error(e); }
})();
})();
